export default __webpack_public_path__ + "static/media/login_cut_vh2.52b1bdfe.png";